import i18n from "i18next";
import {initReactI18next} from "react-i18next";

//Language imports
import en from "./lng/en.json"
import de from "./lng/de.json"
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(I18nextBrowserLanguageDetector)
    .init({
        supportedLngs: ['en', 'de'],
        resources: {
            compatibilityJSON: 'v3',
            en: {translation: en},
            de: {translation: de},
        },
        react: {
            useSuspense: false,
        },
        fallbackLng: ["en"],
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    }).then();

export default i18n;
